var map = {
	"./friday-en.png": 8515,
	"./friday-es.png": 9670,
	"./monday-en.png": 9940,
	"./monday-es.png": 6753,
	"./saturday-en.png": 1108,
	"./saturday-es.png": 6290,
	"./sunday-en.png": 9420,
	"./sunday-es.png": 5817,
	"./thursday-en.png": 1866,
	"./thursday-es.png": 7759,
	"./tuesday-en.png": 4289,
	"./tuesday-es.png": 9844,
	"./wednesday-en.png": 5618,
	"./wednesday-es.png": 7623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2721;